import React from 'react';
import { withFaroProfiler } from '@grafana/faro-react';

/**
 * Page component split out from App to allow for profiling
 */
const Page = ({
  Component,
  path,
  configureSidebar,
  userDetails,
  oauthAccessToken,
  accessDetails,
  portalJwt,
  startTracking,
  setTheme,
  configureNavigation,
  featureFlags,
}: ModuleComponentProps & {
  Component: React.ComponentType<ModuleComponentProps>;
}): JSX.Element => (
  <Component
    path={path}
    configureSidebar={configureSidebar}
    userDetails={userDetails}
    oauthAccessToken={oauthAccessToken}
    accessDetails={accessDetails}
    portalJwt={portalJwt}
    startTracking={startTracking}
    setTheme={setTheme}
    configureNavigation={configureNavigation}
    featureFlags={featureFlags}
  />
);

export default withFaroProfiler(Page);
